export const ADD_ALERT = 'ADD_ALERT';
export const UPDATE_ALERT = 'UPDATE_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
